module.exports = __webpack_public_path__ + "media/images/google_signin-56f00e35d133cf44f6590c095ce984da.png";